
import { useStore } from 'react-admin';
import { dateToFilterString } from '../models/date-to-filter-string';
import { filterDefaultFromDate, filterDefaultToDate } from '../components/global-map-filter/global-map-filter';

export const useDateRange = (): [string, string] => {
  const [dateRange] = useStore<string[]>('map.dateRange', [dateToFilterString(filterDefaultFromDate), dateToFilterString(filterDefaultToDate)]);
  return [dateRange[0], dateRange[1]];
}
